import {AuctionsProvider, useAuctions} from './context/AuctionsContext';
import Step1 from '../../components/AdFlow/Step1';
import Step2 from '../../components/AdFlow/Step2';
import Step3 from '../../components/AdFlow/Step3';
import VBStepper from '@vb-js-commons/new/vbStepper';
import VBLoadingScreen from '@vb-js-commons/vbLoadingScreen';
import { Alert, Modal } from 'react-bootstrap';

import Navigation from '../../components/static/Navigation';
import Footer from '../../components/static/Footer';

const AuctionsCreateContent = () => {
    const {
        step, setStep, adData, isStep1Valid, isStep2Valid,
        saveDraft, draftSaved, handleFinish, errorModal, setErrorModal,
        errorModalText, handleBack, loading
    } = useAuctions();

    const redirectAfterServerError = () => {
        window.location.href = '/';
    };

    const isStep1Complete = isStep1Valid();
    const isStep2Complete = isStep2Valid();

    const handleButtonClick = (e) => {
        e.preventDefault();
        if (step === 1 && isStep1Complete) setStep(step + 1);
        else if (step === 2 && isStep2Complete) setStep(step + 1);
        else alert('Vänligen fyll i alla fält.');
    };
    return (
        <div className="container-fluid p-0">
            <VBLoadingScreen show_loading={loading} disable_reload_timeout={true} />

            <Navigation />

            <div className="bg-white"></div>

            <section className='n-fs-6 pt-0 pt-md-0 pb-0'>
                <div className="container bg-white pt-3 pb-3">
                    <div className='my-4'>
                        <VBStepper currentStep={step} />
                    </div>

                    {step === 1 && adData ? (
                        <>
                            <Step1 />
                            <div className='d-flex justify-content-end mt-4 col-12'>
                                <div className='col-md-4 col-lg-2 col-6 me-2 mb-2 mb-lg-0'>
                                    <button
                                        className='n-btn btn-ghost btn-charcoal m-1 w-100'
                                        onClick={saveDraft}
                                    >
                                        Spara utkast
                                    </button>
                                </div>
                                <div className='col-md-4 col-lg-2 col-6'>
                                    <button
                                        className={`n-btn btn-forest-green m-1 w-100 ${isStep1Complete ? '' : 'disabled'}`}
                                        onClick={handleButtonClick}
                                        disabled={!isStep1Complete}
                                        style={{ color: isStep1Complete ? '#FFFFFF' : '#9d9fa1', backgroundColor: isStep1Complete ? '#023436' : '#F5F5F5' }}
                                    >
                                        Nästa
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : step === 2 ? (
                        <>
                            <Step2 />
                            <div className='d-flex flex-wrap justify-content-end mt-4 col-12'>
                                <div className='col-md-4 col-lg-2 col-5 me-auto mb-2'>
                                    <button
                                        className='n-btn btn-outline btn-charcoal w-100'
                                        onClick={handleBack}
                                    >
                                        Föregående
                                    </button>
                                </div>
                                <div className='col-md-4 col-lg-2 col-6'>
                                    <button
                                        className='n-btn btn-ghost btn-charcoal w-100'
                                        onClick={saveDraft}
                                    >
                                        Spara utkast
                                    </button>
                                </div>
                                <div className='ms-2 col-md-4 col-lg-2 col-12'>
                                    <button
                                        className={`n-btn btn-forest-green m-1 w-100 ${isStep2Valid ? '' : 'disabled'}`}
                                        onClick={handleButtonClick}
                                        disabled={!isStep2Valid}
                                        style={{ color: isStep2Valid ? '#FFFFFF' : '#9d9fa1', backgroundColor: isStep2Valid ? '#023436' : '#F5F5F5' }}
                                    >
                                        Nästa
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : step === 3 ? (
                        <>
                            <Step3/>
                            <div className='d-flex flex-wrap justify-content-end mt-4 col-12'>
                                <div className='ol-md-4 col-lg-2 col-5 me-auto mb-2'>
                                    <button
                                        className='n-btn btn-outline btn-charcoal'
                                        onClick={handleBack}>
                                        Föregående
                                    </button>
                                </div>
                                <div className='col-md-4 col-lg-2 col-6'>
                                    <button
                                        className='n-btn btn-ghost btn-charcoal w-100'
                                        onClick={saveDraft}>
                                        Spara utkast
                                    </button>
                                </div>
                                <div className='ms-2 col-md-4 col-lg-2 col-12'>
                                    <button
                                        className='n-btn btn-forest-green w-100'
                                        onClick={handleFinish}>
                                        Slutför
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
            </section>

            <div style={{ width: '90%', position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: '1000' }}>
                {draftSaved && (
                    <Alert variant="success" dismissible onClose={() => { }}>
                        <Alert.Heading>Ditt utkast har sparats!</Alert.Heading>
                    </Alert>
                )}
            </div>

            <Modal show={errorModal} onHide={() => {setErrorModal(false); redirectAfterServerError()}} centered>
                <Modal.Header closeButton>
                    <h3 className="neutral-charcoal mb-0">Oops! Något gick fel.</h3>
                </Modal.Header>
                <Modal.Body>
                    <p className='neutral-charcoal'>{errorModalText}</p>
                    <p className='neutral-charcoal'>
                        Ring <a href="tel:08339944" className="fw-bold neutral-charcoal">08-33 99 44</a> så hjälper vi dig vidare.
                    </p>
                    <button type="button" className="n-btn float-end" style={{ background: "#FF5B6C", border: "None" }} onClick={() => setErrorModal(false)}>FORTSÄTT</button>
                </Modal.Body>
            </Modal>

            <Footer />
        </div>
    );
};


const AuctionsCreatePage = () => {
    return (
        <AuctionsProvider>
            <AuctionsCreateContent />
        </AuctionsProvider>
    );
};

export default AuctionsCreatePage;

